module.exports = __webpack_public_path__ + "images/accordian5098fea9d57f23efa15c3cb93f6487c7.svg";